import { LOGIN_USER, LOGIN_SUCCESS, LOGOUT_USER, LOGOUT_USER_SUCCESS, API_ERROR } from './actionTypes';

const initialState = {
	error: '',
	loading: false,
	userData: null,
	userRole: null
};

const login = (state = initialState, action) => {
	switch (action.type) {
		case LOGIN_USER:
			state = {
				...state,
				loading: true,
				error: '',
				userData: null,
				userRole: null
			};
			break;
		case LOGIN_SUCCESS:
			state = {
				...state,
				loading: false,
				isUserLogout: false,
				userData: action.payload,
				userRole: action.payload?.role || null
			};
			break;
		case 'SET_USER_DATA_FROM_LOCAL_STORAGE':
			state = {
				...state,
				userData: action.payload,
				userRole: action.payload?.role || null
			};
			break;
		case LOGOUT_USER:
			state = { ...state, userData: null, userRole: null };
			break;
		case LOGOUT_USER_SUCCESS:
			state = { ...state, isUserLogout: true, loading: false, userData: null, userRole: null };
			break;
		case API_ERROR:
			state = { ...state, error: action.payload?.message, loading: false, isUserLogout: false };
			break;
		default:
			state = { ...state };
			break;
	}
	return state;
};

export default login;
